import { getTeamDetailUrl } from "@/helper/urlHelper";
import { Season } from "@/models/Season";
import { useTranslation } from "next-i18next";
import { DocumentLink } from "../common/DocumentLink";
import { LeagueTeam } from "../../models/LeagueTeam";
import { TeamImage } from "../common/Images";
import { NoItems } from "../common/NoItems";

interface TableProps {
  teams: LeagueTeam[];
  season: Season;
}
export function TableList({ teams, season }: TableProps) {
  const { t } = useTranslation();
  if (teams.length === 0) {
    return <NoItems />;
  }
  return (
    <div className="container container-no-padding xl:rounded-md overflow-hidden">
      <div className="max-lg:hidden grid grid-cols-11 text-gray-text text-md px-4">
        <div className="text-center w-4">{t("Label_Rank")}</div>
        <div className="col-span-4">{t("Label_Team")}</div>
        <div className="text-center">{t("Label_Encounters")}</div>
        <div className="text-center">{t("Label_Wins")}</div>
        <div className="text-center">{t("Label_Losses")}</div>
        <div className="text-center">{t("Label_Games")}</div>
        <div className="text-center ">{t("Label_+/-")}</div>
        <div className="text-center ">{t("Label_Points")}</div>
      </div>
      {teams.map((team) => (
        <TableCard team={team} key={team.id} season={season} />
      ))}
    </div>
  );
}

interface TableCardProps {
  team: LeagueTeam;
  season: Season;
}
function TableCard({ team, season }: TableCardProps) {
  const rankStyle =
    team.rank <= 4 ? "winning" : team.rank >= 11 ? "losing" : "";
  return (
    <div className="bg-white flex items-center border-b border-gray-light group last:border-none py-4 lg:border-none lg:grid lg:grid-cols-11 lg:rounded-lg lg:bg-bg-gray lg:p-4 lg:my-4">
      <div className="flex items-center">
        <div className={`text-center px-3 py-1 ${rankStyle}`}>{team.rank}</div>
        {/* <div className="table-rank-up ml-2">
          <FiChevronUp />
        </div> */}
      </div>
      <div className="col-span-4">
        <DocumentLink
          className="flex lg:gap-4 items-center"
          href={getTeamDetailUrl({
            league: "Bundesliga",
            season,
            teamId: team.seasonTeam.id,
          })}
        >
          <TeamImage
            team={team.seasonTeam}
            className="shrink-0"
            size="md"
            contain={false}
          />

          <div className="max-md:hidden ml-4 ">{team.seasonTeam.name}</div>
          <div className="lg:hidden ml-2 whitespace-nowrap">
            {team.seasonTeam.shortname}
          </div>
        </DocumentLink>
      </div>
      <div className="text-center">{team.matchCount}</div>
      <div className="text-center">{team.matchWins}</div>
      <div className="text-center">{team.matchLosses}</div>
      <div className="text-center divacking-wide">{`${team.gameWins} : ${team.gameLosses}`}</div>
      <div className="text-center tracking-wide">
        {team.gameWins - team.gameLosses}
      </div>
      <div className="text-center font-bold">{`${team.matchWins * 2} : ${
        team.matchLosses * 2
      }`}</div>
    </div>
  );
}
